<template>
    <section class="form__section__container">
        <div class="wrapper__texts">
            <div class="low__text" data-animate="slideUp">{{ fields['Title section'] }}</div>
            <div class="text" data-animate="slideUp">{{ fields['Text section'] }}</div>
            <a href="#">
                View Machines
                <svg width="15.000000" height="10.000000" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs/>
                    <path id="Union" d="M12.74 4.42L9.02 0.81L9.86 0L14.58 4.59L15 5L14.58 5.4L9.86 10L9.02 9.18L12.74 5.57L0 5.57L0 4.42L12.74 4.42Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
                </svg>
            </a>
        </div>
        <div class="form__wrapper">
            <div class="left">
                <div class="item" v-for="(item,index) in fields['Repeater']" data-animate="slideUp">
                    <div class="number">{{index+1}}</div>
                    <div class="text">{{item.text}}</div>
                </div>
            </div>
            <div class="right">
                <form action="" id="sell">
                    <div class="informarion__wrapper">
                        <div class="title">Account Details</div>
                        <div class="blok__wrapper">
                            <div class="input__wrapper">
                                <div class="name">First Name</div>
                                <input type="text" v-model="v$.valueField.name.$model" :class="{ 'error': v$.valueField.name.$invalid && submitted }">
                                <div class="alert" v-if="v$.valueField.name.$invalid && submitted">Enter name</div>
                            </div>
                            <div class="input__wrapper">
                                <div class="name">Second Name</div>
                                <input type="text" v-model="v$.valueField.last_name.$model" :class="{ 'error': v$.valueField.last_name.$invalid && submitted }">
                                <div class="alert" v-if="v$.valueField.last_name.$invalid && submitted">Enter last name</div>
                            </div>
                        </div>
                        <div class="blok__wrapper">
                            <div class="input__wrapper">
                                <div class="name">Email</div>
                                <input type="email" v-model="v$.valueField.email.$model" :class="{ 'error': v$.valueField.email.$invalid && submitted }">
                                <div class="alert" v-if="v$.valueField.email.$invalid && submitted">Enter your mail</div>
                            </div>
                            <div class="input__wrapper">
                                <div class="name">Mobile Phone number</div>
                                <VueCountryIntl v-model="v$.valueField.phone.$model" :class="{ 'error': v$.valueField.phone.$invalid && submitted }"></VueCountryIntl>
                                <div class="alert" v-if="v$.valueField.phone.$invalid && submitted">Enter your phone number</div>
                            </div>
                        </div>
                    </div>
                    <div class="informarion__wrapper">
                        <div class="title">Machine Information</div>
                        <div class="blok__wrapper">
                            <div class="input__wrapper">
                                <div class="name">manufacturer</div>
                                <CustomSelect v-model="v$.valueField.manufacturer.$model" :options="manufacturers" @change="fetchModels" :data_name="'name'" :class="{ 'error': v$.valueField.manufacturer.$invalid && submitted }"></CustomSelect>
                                <div class="alert" v-if="v$.valueField.manufacturer.$invalid && submitted">Select a manufacturer</div>
                            </div>
                        </div>
                        <div class="blok__wrapper">
                            <div class="input__wrapper">
                                <div class="name">Model</div>
                                <CustomSelect v-model="v$.valueField.model.$model" :options="models" @change="fetchYears" :data_name="'name'" :class="{ 'error': v$.valueField.model.$invalid && submitted }"></CustomSelect>
                                <div class="alert" v-if="v$.valueField.model.$invalid && submitted">Select a model</div>
                            </div>
                            <div class="input__wrapper">
                                <div class="name">year</div>
                                <CustomSelect v-model="v$.valueField.year.$model" :options="years" :data_name="'year'" :class="{ 'error': v$.valueField.year.$invalid && submitted }"></CustomSelect>
                                <div class="alert" v-if="v$.valueField.year.$invalid && submitted">Select a year</div>
                            </div>
                        </div>
                    </div>
                    
                </form>
                <ButtonOrange style="width: 168px; margin-top: 50px;" @click="submitForm">Send</ButtonOrange>
            </div>
        </div>
    </section>
</template>

<script>
import VueCountryIntl from "@/components/UI/VueCountryIntl.vue";
import CustomSelect from "@/components/UI/CustomSelect.vue";
import ButtonOrange from "../UI/ButtonOrange.vue";
import axios from "axios";
import { useVuelidate } from '@vuelidate/core'
import { required, email} from '@vuelidate/validators';
    export default {
        setup: () => ({ v$: useVuelidate() }),
        props: {
            fields: [Array,Object],
        },
        components: {
            CustomSelect,
            VueCountryIntl,
            ButtonOrange
        },
        data() {
            return {
                valueField: {
                    name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    manufacturer: '',
                    model: '',
                    year: '',
                },
                manufacturers: [],
                models: [],
                years: [],
                submitted: false,
                request: false,
            }
        },
        validations() {
            return {
                valueField: {
                    name: { required },
                    last_name: { required },
                    phone: { required },
                    email: { required, email },
                    manufacturer: { required },
                    model: { required },
                    year: { required },
                }
            }
        },
        mounted() {
            this.fetchManufacturers();
        },
        methods: {
            async fetchManufacturers() {
            try {
                const response = await axios.get('/products/manufacturers');
                this.manufacturers = response.data;
            } catch (error) {
                console.error('Ошибка при загрузке производителей:', error);
            }
            },
            async fetchModels() {
            try {
                const response = await axios.get('/products/models', {
                params: { manufacturer: this.valueField.manufacturer },
                });
                this.models = response.data;
                this.selectedModel = null; // Сбросить выбранную модель
                this.years = []; // Очистить годы
            } catch (error) {
                console.error('Ошибка при загрузке моделей:', error);
            }
            },
            async fetchYears() {
            try {
                const response = await axios.get('/products/years', {
                params: { model: this.valueField.model },
                });
                this.years = response.data;
                this.selectedYear = null; // Сбросить выбранный год
            } catch (error) {
                console.error('Ошибка при загрузке годов:', error);
            }
            },
            submitForm(e){
                e.preventDefault();
                this.submitted = true;

                if(this.request){
                    return false;
                }
                this.request = true;
                this.v$.$touch();
                if (this.v$.valueField.$invalid) {
                    this.request = false;
                } else {
                    const formData = { ...this.valueField };
                    axios.post('/submit-form', formData)
                    .then(response => {
                    // Обработка успешного ответа
                    this.resetForm();
                    })
                    .catch(error => {
                    // Обработка ошибки
                    })
                    .finally(() => {
                    this.request = false; // Разблокировать запрос
                    });
                }
            }
        },
        
    }
</script>

<style scoped>
.alert{
  color: red;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  opacity: 0.8;
  padding-top: 6px;
}
form{
    display: flex;
    flex-direction: column;
    gap: 64px;
}
.right{
    width: 100%;
}
.informarion__wrapper .title{
    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    padding-bottom: 8px;
}
.informarion__wrapper{
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.blok__wrapper{
    display: flex;
    gap: 32px;
    width: 100%;
}
.input__wrapper{
    width: 100%;
}
.input__wrapper .name{
    color: rgb(85, 98, 114);
    font-size: 11px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    text-transform: uppercase;
    padding-bottom: 5px;
}
input{
    box-sizing: border-box;
    border: 1px solid rgb(222, 230, 234);
    border-radius: 8px;
    background: rgb(255, 255, 255);
    width: 100%;
    height: 44px;
    padding-left: 10px;
    min-width: 266px
}
input.error{
    border: 1px solid red;
}
.input__wrapper .input__wrapper{
    color: rgb(85, 98, 114);
    font-size: 11px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    text-transform: uppercase;
}
.form__wrapper{
    display: flex;
    gap: 200px;
}
.left{
    width: 100%;
    max-width: 472px;
}
.left .item{
    display: flex;
    gap: 24px;
    align-items: center;
    padding: 24px 0;
    border-bottom: 1px solid rgb(222, 230, 234);
}
.left .item:first-child{
    padding-top: 0;
}
.left .item:last-child{
    border-bottom: unset;
}
.left .item .number{
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180.00deg, rgb(173, 184, 199),rgb(222, 230, 234) 100%);
    border-radius: 100%;
    width: 56px;
    height: 56px;

    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
.left .item .text{
    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
.wrapper__texts{
    position: relative;
    margin-bottom: 36px;
}
.wrapper__texts .low__text{
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    padding-bottom: 10px;
}
.wrapper__texts .text{
/* Header/H1: 44px Medium */
    color: rgb(5, 5, 5);
    font-size: 44px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    max-width: 640px;
}
.wrapper__texts a{
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
@media (max-width: 1250px) {
.form__wrapper{
    gap: 20px;
}
}
/* @media (max-width: 1060px) {
    .blok__wrapper[data-v-d448c99a] {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
    }
} */
@media (max-width: 1024px) {
    .wrapper__texts .text{
        font-size: 44px;
        max-width: 100%;
    }
    .wrapper__texts a{
        bottom: unset;
        top: 0;
    }

    .form__wrapper{
        flex-direction: column;
        gap: 16px;
    }
    .left .item .text{
        font-size: 20px;
    }
    .form__wrapper .left, 
    .form__wrapper .right{
        width: 100%;
        max-width: 100%;
    }
    form{
        gap: 32px;
    }
    .wrapper__texts .text{
        font-size: 32px;
    }
    .blok__wrapper{
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
    }
}
@media (max-width: 768px) {
    .wrapper__texts .text{
        font-size: 22px;
    }
    .left .item{
        padding: 16px 0;
    }
    .left .item .text{
        font-size: 18px;
    }
    .left .item .number{
        font-size: 20px;
        width: 44px;
        height: 44px;
    }
}
</style>